import { render, staticRenderFns } from "./profile-contact.vue?vue&type=template&id=76632003&scoped=true&"
import script from "./profile-contact.ts?vue&type=script&lang=ts&"
export * from "./profile-contact.ts?vue&type=script&lang=ts&"
import style0 from "./profile-contact.scss?vue&type=style&index=0&id=76632003&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76632003",
  null
  
)

export default component.exports